export default function replaceUnderscores (text) {
  return text.replace(/\b(___+)\b/, '<span>$1</span>')
}
